import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { setOrderInboxCount } from '../slices/planningPageSlice'

export const fetchOrderInboxCount = createAsyncThunk('planning/fetchOrderInboxCount', async (_, { dispatch }) => {
  const orderInboxCount = await OLMSApiService.get<number>('/planning/OrderInboxCount')

  dispatch(setOrderInboxCount(orderInboxCount))
})
